export const environment = {
  production: false,
  orgId: 'ndphc',
  orgName: 'Niger Delta Power Holding Company Limited',
  orgShortName: 'NDPHC',
  mockDataPath: 'assets/mock-data/ndphc',
};
